<template>
    <!-- <div> -->
    <contratos
        :dataServicos="obterDataServicos()"
        rotaDetalhar="Gescon_Gerentes_Contratos_Detalhar"
        rotaListagem="Gescon_Gerentes_Contratos"
        :permiteDetalhar="$temAcessoView('GESCON-GER-CONT-00')"
    ></contratos>
    <!-- </div> -->
</template>

<script>
import ContratosServicos from './ContratosServicos'
import Contratos from '../../contratos/Contratos2.vue'

export default {
    methods: {
        obterDataServicos() {
            return ContratosServicos
        }
    },

    components: {
        Contratos
    }
}
</script>
